export const translations = {
  it: {
    // Header
    nav: {
      myStory: "La Mia Storia",
      ecosystem: "Ecosistema",
      plans: "Piani",
      myLetters: "Le Mie Lettere",
      patientArea: "Area Paziente",
      book: "Prenota"
    },
    
    // Hero
    hero: {
      badge: "Benessere Olistico",
      title1: "Riscopri il tuo",
      titleHighlight: "equilibrio",
      title2: "corpo e mente",
      subtitle: "Un percorso personalizzato di fisioterapia e benessere olistico, pensato per uomini e donne che desiderano ritrovare armonia e vitalità.",
      cta1: "Scopri i Piani",
      cta2: "La Mia Storia",
      stat1: "Anni di esperienza",
      stat2: "Pazienti aiutati",
      stat3: "Approccio olistico"
    },
    
    // Biography
    bio: {
      label: "Chi Sono",
      name: "Marlene Brochero",
      p1: "Da oltre <strong>30 anni</strong> mi dedico con passione alla cura del corpo e della mente. Il mio percorso professionale mi ha portato a specializzarmi in <strong>fisioterapia sportiva</strong> e <strong>riabilitazione cardiologica</strong>, aiutando centinaia di pazienti a recuperare la loro piena funzionalità.",
      p2: "Nel tempo ho integrato il mio approccio con discipline olistiche, diventando <strong>operatore olistico certificato</strong>. Credo fermamente che il vero benessere nasca dall'armonia tra corpo, mente e spirito. Questo è ciò che trasmetto attraverso Phisioletters: un metodo unico che unisce scienza e cura dell'essere nella sua totalità.",
      cred1: "Fisioterapia",
      cred1sub: "Sportiva & Cardiologica",
      cred2: "Olistica",
      cred2sub: "Operatore Certificato",
      cred3: "Esperienza",
      cred3sub: "Oltre 30 anni"
    },
    
    // Method
    method: {
      label: "Il Metodo",
      title1: "Non fisioterapia classica.",
      title2: "Traduzione del linguaggio del corpo.",
      subtitle: "Unisco oltre 30 anni di pratica clinica, approccio olistico ed emozione per aiutarti a capire cosa il tuo corpo sta cercando di dirti — e cosa fare davvero al riguardo.",
      interpretation: "Interpretazione",
      interpretationText: "Traduco dolori, tensioni e blocchi in messaggi comprensibili. Il sintomo diventa finalmente un segnale con un senso,",
      interpretationHighlight: " non un nemico da combattere.",
      deep: "Comprensione profonda",
      deepText: "Ogni dolore ha una storia. Insieme la scopriamo e la trasformiamo.",
      holistic: "Approccio olistico",
      holisticText: "Corpo, mente e spirito connessi in un percorso unico e personale."
    },
    
    // Ecosystem
    ecosystem: {
      label: "Il Metodo",
      title: "Un ecosistema unico",
      subtitle: "Tre livelli progressivi pensati per accompagnarti nel tuo percorso di benessere, dal primo contatto fino a un'esperienza completamente personalizzata.",
      level1: {
        subtitle: "Ingresso Emotivo",
        title: "Instagram",
        description: "Segui @phisioletters per ispirazioni quotidiane, consigli pratici e contenuti che nutrono corpo e mente. Il primo passo verso il tuo benessere.",
        cta: "Segui su Instagram"
      },
      level2: {
        subtitle: "Core Business",
        title: "Community",
        description: "Entra nella community su Skool dove troverai video esclusivi, esercizi guidati e il supporto di una comunità che condivide il tuo percorso.",
        cta: "Entra nella Community"
      },
      level3: {
        subtitle: "Consulenza 1:1",
        title: "Premium",
        description: "L'esperienza più esclusiva: consulenze personalizzate, un piano su misura per te e lettere fisiche che ti accompagnano nel tuo percorso.",
        cta: "Scopri Premium"
      },
      popular: "Più popolare",
      letterTitle: "Lettere fisiche personalizzate",
      letterText: "Nel piano Premium riceverai lettere scritte a mano, sigillate con cera, contenenti il tuo piano personalizzato, riflessioni e consigli esclusivi. Un tocco di autenticità in un mondo digitale.",
      letterCta: "Scopri Premium"
    },
    
    // Pricing
    pricing: {
      label: "Abbonamenti",
      title: "Scegli il tuo percorso",
      subtitle: "Tre piani pensati per accompagnarti nel tuo viaggio di benessere, dal primo passo fino a un'esperienza completamente personalizzata.",
      base: "Base",
      recommended: "Consigliato",
      exclusive: "Esclusivo",
      popular: "Più popolare",
      vip: "VIP",
      month: "/mese",
      subscribe: "Iscriviti",
      becomeVip: "Diventa VIP",
      bookConsultation: "Prenota Consulenza 1:1",
      proceed: "Procedi al pagamento",
      nameLabel: "Il tuo nome",
      emailLabel: "La tua email",
      preferredNameLabel: "Come vuoi che ti chiami?",
      preferredNamePlaceholder: "Es: Maria, Mari, Marita...",
      note: "Tutti i piani includono l'accesso alla community Skool. Cancellazione possibile in qualsiasi momento."
    },
    
    // Booking
    booking: {
      label: "Esclusivo Premium Fisico",
      title: "Prenota la tua consulenza 1:1",
      subtitle: "Scegli una data e un orario per la tua sessione personalizzata con Marlene.",
      premiumOnly: "Disponibile esclusivamente per gli abbonati Premium Fisico (€55/mese).",
      selectDate: "Seleziona una data",
      availableSlots: "Orari disponibili",
      noSlots: "Nessun orario disponibile per questa data",
      yourData: "I tuoi dati",
      fullName: "Nome completo *",
      email: "Email *",
      notes: "Note (opzionale)",
      notesPlaceholder: "Descrivici brevemente le tue esigenze...",
      summary: "Riepilogo prenotazione:",
      confirm: "Conferma Prenotazione",
      reserved: "Riservato agli abbonati Premium Fisico (€55/mese).",
      successTitle: "Appuntamento Confermato!",
      successText: "il tuo appuntamento è stato prenotato per:",
      emailConfirm: "Riceverai una email di conferma all'indirizzo"
    },
    
    // Letters
    letters: {
      label: "Area Personale",
      title: "Le Mie Lettere",
      subtitle: "Inserisci la tua email per visualizzare e scaricare le tue lettere personalizzate.",
      search: "Cerca",
      noLetters: "Nessuna lettera trovata per questa email.",
      checkEmail: "Assicurati di usare la stessa email con cui ti sei iscritto/a.",
      waiting: "Le tue lettere ti aspettano",
      waitingText: "Come abbonato Premium, ricevi lettere personalizzate ogni mese. Inserisci la tua email per accedere all'archivio completo.",
      notActive: "Abbonamento non attivo",
      notActiveText: "Puoi visualizzare le tue lettere, ma per scaricarle in PDF devi avere un abbonamento attivo.",
      discoverPlans: "Scopri i Piani",
      backToLetters: "Torna alle mie lettere",
      dear: "Caro/a",
      withAffection: "Con affetto,",
      downloadPdf: "Scarica la tua lettera in PDF",
      pdfNote: "Il PDF include l'intestazione con il logo dello studio",
      downloadReserved: "Download riservato agli abbonati",
      downloadReservedText: "Per scaricare questa lettera in PDF, attiva un abbonamento."
    },
    
    // Footer
    footer: {
      description: "Un percorso di benessere fisico e mentale guidato da oltre 30 anni di esperienza. Riscopri il tuo equilibrio con un approccio olistico e personalizzato.",
      navigate: "Naviga",
      connect: "Connettiti",
      communitySkool: "Community Skool",
      privacy: "Privacy Policy",
      terms: "Termini di Servizio",
      rights: "Tutti i diritti riservati."
    },
    
    // Success page
    success: {
      verifying: "Verifica pagamento in corso...",
      wait: "Stiamo verificando il tuo pagamento, attendere prego.",
      completed: "Pagamento Completato!",
      thanks: "Grazie per il tuo acquisto! Il tuo abbonamento è ora attivo. Riceverai una email di conferma con tutti i dettagli per accedere alla community Skool.",
      summary: "Riepilogo:",
      amount: "Importo:",
      status: "Stato:",
      paid: "Pagato",
      backHome: "Torna alla Home",
      expired: "Sessione Scaduta",
      expiredText: "La sessione di pagamento è scaduta. Per favore riprova.",
      failed: "Verifica non riuscita",
      failedText: "Non siamo riusciti a verificare il pagamento. Se hai completato il pagamento, contattaci.",
      backToPlans: "Torna ai Piani",
      patientAreaCta: "Vai all'Area Paziente",
      questionnaireHint: "Crea il tuo account nell'Area Paziente e compila il questionario iniziale per ricevere la tua scheda esercizi personalizzata."
    },
    
    // Auth
    auth: {
      loginTitle: "Accedi",
      registerTitle: "Crea il tuo account",
      name: "Nome",
      email: "Email",
      password: "Password",
      loginBtn: "Accedi",
      registerBtn: "Registrati",
      noAccount: "Non hai un account? Registrati",
      haveAccount: "Hai già un account? Accedi",
      welcome: "Benvenuto/a!",
      logout: "Esci",
      forgotPassword: "Password dimenticata?",
      forgotTitle: "Recupera la password",
      forgotText: "Inserisci la tua email: ti invieremo un link per reimpostare la password.",
      sendLink: "Invia link di recupero",
      forgotSent: "Se l'email esiste, riceverai un link di recupero.",
      backToLogin: "Torna al login",
      resetTitle: "Imposta una nuova password",
      newPassword: "Nuova password",
      confirmPassword: "Conferma password",
      resetBtn: "Reimposta password",
      resetSuccess: "Password aggiornata! Ora puoi accedere.",
      passwordMismatch: "Le password non coincidono"
    },
    
    // Patient Area
    patientArea: {
      label: "Area Privata",
      title: "Il mio Programma di Esercizi",
      welcome: "Ciao",
      myLetters: "Le mie lettere",
      noAccess: "Programma riservato agli abbonati Premium",
      noAccessText: "Il programma di esercizi personalizzato è disponibile per gli abbonati Premium Digitale e Premium Fisico. Attiva un piano per ricevere la tua scheda.",
      discoverPlans: "Scopri i Piani",
      noProgram: "La tua scheda è in preparazione",
      noProgramText: "Marlene sta preparando il tuo programma personalizzato. Lo troverai qui appena pronto.",
      questionnaireBanner: "Completa il questionario iniziale",
      questionnaireBannerText: "Le tue risposte aiuteranno Marlene a preparare la tua scheda personalizzata.",
      fillQuestionnaire: "Compila ora",
      questionnaireDone: "Questionario iniziale completato",
      progress: "Progresso della scheda",
      sets: "Serie",
      reps: "Ripetizioni",
      frequency: "Frequenza",
      rest: "Recupero",
      perWeek: "x/sett.",
      mistakes: "Errori da evitare",
      watchVideo: "Guarda il video",
      hideVideo: "Nascondi il video",
      completed: "Completato",
      markCompleted: "Segna come completato",
      today: "Oggi",
      todayTitle: "Da fare oggi",
      todayNone: "Oggi nessun esercizio in programma: giornata di recupero!",
      buy: "Acquista",
      equipmentLabel: "Attrezzatura necessaria",
      consultTitle: "La tua consulenza 1:1 mensile",
      consultText: "Ricorda di prenotare la tua videochiamata mensile con Marlene, inclusa nel tuo piano Premium Fisico.",
      consultBooked: "Prossima consulenza:",
      consultCta: "Prenota ora",
      streakWeek: "settimana di fila — continua così!",
      streakWeeks: "settimane di fila — continua così!",
      difficulty: {
        easy: "Facile",
        medium: "Medio",
        hard: "Difficile"
      }
    },
    
    // Questionnaire
    questionnaire: {
      title: "Questionario Iniziale",
      subtitle: "Le tue risposte aiuteranno Marlene a preparare la tua scheda personalizzata.",
      painType: "Che tipo di dolore hai?",
      painPlaceholder: "Es: dolore cervicale quando lavoro al computer...",
      goal: "Qual è il tuo obiettivo?",
      goalPlaceholder: "Es: tornare a correre senza dolore...",
      equipment: "Che attrezzatura hai a casa?",
      equipmentPlaceholder: "Es: tappetino, elastici, pesi leggeri... (o nessuna)",
      activityLevel: "Livello di attività fisica",
      levels: {
        sedentary: "Sedentario",
        light: "Leggero",
        moderate: "Moderato",
        active: "Attivo"
      },
      notes: "Note aggiuntive (opzionale)",
      submit: "Invia questionario",
      success: "Questionario inviato! Grazie."
    },
    
    // Common
    common: {
      loading: "Caricamento...",
      error: "Errore",
      backHome: "Torna alla Home",
      notFound: "Non trovato"
    }
  },
  
  en: {
    // Header
    nav: {
      myStory: "My Story",
      ecosystem: "Ecosystem",
      plans: "Plans",
      myLetters: "My Letters",
      patientArea: "Patient Area",
      book: "Book"
    },
    
    // Hero
    hero: {
      badge: "Holistic Wellness",
      title1: "Rediscover your",
      titleHighlight: "balance",
      title2: "body and mind",
      subtitle: "A personalized journey of physiotherapy and holistic wellness, designed for men and women who wish to find harmony and vitality.",
      cta1: "Discover Plans",
      cta2: "My Story",
      stat1: "Years of experience",
      stat2: "Patients helped",
      stat3: "Holistic approach"
    },
    
    // Biography
    bio: {
      label: "About Me",
      name: "Marlene Brochero",
      p1: "For over <strong>30 years</strong> I have dedicated myself with passion to caring for body and mind. My professional journey led me to specialize in <strong>sports physiotherapy</strong> and <strong>cardiac rehabilitation</strong>, helping hundreds of patients regain their full functionality.",
      p2: "Over time I integrated my approach with holistic disciplines, becoming a <strong>certified holistic operator</strong>. I firmly believe that true well-being comes from harmony between body, mind and spirit. This is what I transmit through Phisioletters: a unique method that combines science and care for the whole being.",
      cred1: "Physiotherapy",
      cred1sub: "Sports & Cardiac",
      cred2: "Holistic",
      cred2sub: "Certified Operator",
      cred3: "Experience",
      cred3sub: "Over 30 years"
    },
    
    // Method
    method: {
      label: "The Method",
      title1: "Not classical physiotherapy.",
      title2: "Translation of body language.",
      subtitle: "I combine over 30 years of clinical practice, holistic approach and emotion to help you understand what your body is trying to tell you — and what to really do about it.",
      interpretation: "Interpretation",
      interpretationText: "I translate pains, tensions and blockages into understandable messages. The symptom finally becomes a signal with meaning,",
      interpretationHighlight: " not an enemy to fight.",
      deep: "Deep understanding",
      deepText: "Every pain has a story. Together we discover it and transform it.",
      holistic: "Holistic approach",
      holisticText: "Body, mind and spirit connected in a unique and personal journey."
    },
    
    // Ecosystem
    ecosystem: {
      label: "The Method",
      title: "A unique ecosystem",
      subtitle: "Three progressive levels designed to accompany you on your wellness journey, from first contact to a fully personalized experience.",
      level1: {
        subtitle: "Emotional Entry",
        title: "Instagram",
        description: "Follow @phisioletters for daily inspiration, practical tips and content that nourish body and mind. The first step towards your well-being.",
        cta: "Follow on Instagram"
      },
      level2: {
        subtitle: "Core Business",
        title: "Community",
        description: "Join the community on Skool where you'll find exclusive videos, guided exercises and the support of a community that shares your journey.",
        cta: "Join the Community"
      },
      level3: {
        subtitle: "1:1 Consultation",
        title: "Premium",
        description: "The most exclusive experience: personalized consultations, a tailor-made plan for you and physical letters that accompany you on your journey.",
        cta: "Discover Premium"
      },
      popular: "Most popular",
      letterTitle: "Personalized physical letters",
      letterText: "In the Premium plan you will receive handwritten letters, sealed with wax, containing your personalized plan, reflections and exclusive advice. A touch of authenticity in a digital world.",
      letterCta: "Discover Premium"
    },
    
    // Pricing
    pricing: {
      label: "Subscriptions",
      title: "Choose your path",
      subtitle: "Three plans designed to accompany you on your wellness journey, from the first step to a fully personalized experience.",
      base: "Basic",
      recommended: "Recommended",
      exclusive: "Exclusive",
      popular: "Most popular",
      vip: "VIP",
      month: "/month",
      subscribe: "Subscribe",
      becomeVip: "Become VIP",
      bookConsultation: "Book 1:1 Consultation",
      proceed: "Proceed to payment",
      nameLabel: "Your name",
      emailLabel: "Your email",
      preferredNameLabel: "What should we call you?",
      preferredNamePlaceholder: "E.g.: Maria, Mari, Marita...",
      note: "All plans include access to the Skool community. Cancellation possible at any time."
    },
    
    // Booking
    booking: {
      label: "Exclusive Physical Premium",
      title: "Book your 1:1 consultation",
      subtitle: "Choose a date and time for your personalized session with Marlene.",
      premiumOnly: "Available exclusively for Physical Premium subscribers (€55/month).",
      selectDate: "Select a date",
      availableSlots: "Available times",
      noSlots: "No times available for this date",
      yourData: "Your details",
      fullName: "Full name *",
      email: "Email *",
      notes: "Notes (optional)",
      notesPlaceholder: "Briefly describe your needs...",
      summary: "Booking summary:",
      confirm: "Confirm Booking",
      reserved: "Reserved for Physical Premium subscribers (€55/month).",
      successTitle: "Appointment Confirmed!",
      successText: "your appointment has been booked for:",
      emailConfirm: "You will receive a confirmation email at"
    },
    
    // Letters
    letters: {
      label: "Personal Area",
      title: "My Letters",
      subtitle: "Enter your email to view and download your personalized letters.",
      search: "Search",
      noLetters: "No letters found for this email.",
      checkEmail: "Make sure to use the same email you signed up with.",
      waiting: "Your letters are waiting",
      waitingText: "As a Premium subscriber, you receive personalized letters every month. Enter your email to access the complete archive.",
      notActive: "Subscription not active",
      notActiveText: "You can view your letters, but to download them as PDF you need an active subscription.",
      discoverPlans: "Discover Plans",
      backToLetters: "Back to my letters",
      dear: "Dear",
      withAffection: "With affection,",
      downloadPdf: "Download your letter as PDF",
      pdfNote: "The PDF includes the header with the studio logo",
      downloadReserved: "Download reserved for subscribers",
      downloadReservedText: "To download this letter as PDF, activate a subscription."
    },
    
    // Footer
    footer: {
      description: "A journey of physical and mental well-being guided by over 30 years of experience. Rediscover your balance with a holistic and personalized approach.",
      navigate: "Navigate",
      connect: "Connect",
      communitySkool: "Skool Community",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      rights: "All rights reserved."
    },
    
    // Success page
    success: {
      verifying: "Verifying payment...",
      wait: "We are verifying your payment, please wait.",
      completed: "Payment Completed!",
      thanks: "Thank you for your purchase! Your subscription is now active. You will receive a confirmation email with all the details to access the Skool community.",
      summary: "Summary:",
      amount: "Amount:",
      status: "Status:",
      paid: "Paid",
      backHome: "Back to Home",
      expired: "Session Expired",
      expiredText: "The payment session has expired. Please try again.",
      failed: "Verification failed",
      failedText: "We couldn't verify the payment. If you completed the payment, contact us.",
      backToPlans: "Back to Plans",
      patientAreaCta: "Go to Patient Area",
      questionnaireHint: "Create your account in the Patient Area and fill in the initial questionnaire to receive your personalized exercise program."
    },
    
    // Auth
    auth: {
      loginTitle: "Log In",
      registerTitle: "Create your account",
      name: "Name",
      email: "Email",
      password: "Password",
      loginBtn: "Log In",
      registerBtn: "Sign Up",
      noAccount: "Don't have an account? Sign up",
      haveAccount: "Already have an account? Log in",
      welcome: "Welcome!",
      logout: "Log out",
      forgotPassword: "Forgot your password?",
      forgotTitle: "Recover your password",
      forgotText: "Enter your email: we'll send you a link to reset your password.",
      sendLink: "Send recovery link",
      forgotSent: "If the email exists, you'll receive a recovery link.",
      backToLogin: "Back to login",
      resetTitle: "Set a new password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      resetBtn: "Reset password",
      resetSuccess: "Password updated! You can now log in.",
      passwordMismatch: "Passwords don't match"
    },
    
    // Patient Area
    patientArea: {
      label: "Private Area",
      title: "My Exercise Program",
      welcome: "Hi",
      myLetters: "My letters",
      noAccess: "Program reserved for Premium subscribers",
      noAccessText: "The personalized exercise program is available for Digital Premium and Physical Premium subscribers. Activate a plan to receive your program.",
      discoverPlans: "Discover Plans",
      noProgram: "Your program is being prepared",
      noProgramText: "Marlene is preparing your personalized program. You will find it here as soon as it's ready.",
      questionnaireBanner: "Complete the initial questionnaire",
      questionnaireBannerText: "Your answers will help Marlene prepare your personalized program.",
      fillQuestionnaire: "Fill in now",
      questionnaireDone: "Initial questionnaire completed",
      progress: "Program progress",
      sets: "Sets",
      reps: "Reps",
      frequency: "Frequency",
      rest: "Rest",
      perWeek: "x/week",
      mistakes: "Mistakes to avoid",
      watchVideo: "Watch the video",
      hideVideo: "Hide video",
      completed: "Completed",
      markCompleted: "Mark as completed",
      today: "Today",
      todayTitle: "To do today",
      todayNone: "No exercises scheduled today — recovery day!",
      buy: "Buy",
      equipmentLabel: "Required equipment",
      consultTitle: "Your monthly 1:1 consultation",
      consultText: "Remember to book your monthly video call with Marlene, included in your Physical Premium plan.",
      consultBooked: "Next consultation:",
      consultCta: "Book now",
      streakWeek: "week in a row — keep it up!",
      streakWeeks: "weeks in a row — keep it up!",
      difficulty: {
        easy: "Easy",
        medium: "Medium",
        hard: "Hard"
      }
    },
    
    // Questionnaire
    questionnaire: {
      title: "Initial Questionnaire",
      subtitle: "Your answers will help Marlene prepare your personalized program.",
      painType: "What type of pain do you have?",
      painPlaceholder: "E.g.: neck pain when working at the computer...",
      goal: "What is your goal?",
      goalPlaceholder: "E.g.: getting back to running pain-free...",
      equipment: "What equipment do you have at home?",
      equipmentPlaceholder: "E.g.: mat, resistance bands, light weights... (or none)",
      activityLevel: "Physical activity level",
      levels: {
        sedentary: "Sedentary",
        light: "Light",
        moderate: "Moderate",
        active: "Active"
      },
      notes: "Additional notes (optional)",
      submit: "Submit questionnaire",
      success: "Questionnaire submitted! Thank you."
    },
    
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      backHome: "Back to Home",
      notFound: "Not found"
    }
  },
  
  es: {
    // Header
    nav: {
      myStory: "Mi Historia",
      ecosystem: "Ecosistema",
      plans: "Planes",
      myLetters: "Mis Cartas",
      patientArea: "Área Paciente",
      book: "Reservar"
    },
    
    // Hero
    hero: {
      badge: "Bienestar Holístico",
      title1: "Redescubre tu",
      titleHighlight: "equilibrio",
      title2: "cuerpo y mente",
      subtitle: "Un recorrido personalizado de fisioterapia y bienestar holístico, pensado para hombres y mujeres que desean encontrar armonía y vitalidad.",
      cta1: "Descubre los Planes",
      cta2: "Mi Historia",
      stat1: "Años de experiencia",
      stat2: "Pacientes ayudados",
      stat3: "Enfoque holístico"
    },
    
    // Biography
    bio: {
      label: "Quién Soy",
      name: "Marlene Brochero",
      p1: "Desde hace más de <strong>30 años</strong> me dedico con pasión al cuidado del cuerpo y la mente. Mi trayectoria profesional me llevó a especializarme en <strong>fisioterapia deportiva</strong> y <strong>rehabilitación cardíaca</strong>, ayudando a cientos de pacientes a recuperar su plena funcionalidad.",
      p2: "Con el tiempo integré mi enfoque con disciplinas holísticas, convirtiéndome en <strong>operador holístico certificado</strong>. Creo firmemente que el verdadero bienestar nace de la armonía entre cuerpo, mente y espíritu. Esto es lo que transmito a través de Phisioletters: un método único que une ciencia y cuidado del ser en su totalidad.",
      cred1: "Fisioterapia",
      cred1sub: "Deportiva y Cardíaca",
      cred2: "Holística",
      cred2sub: "Operador Certificado",
      cred3: "Experiencia",
      cred3sub: "Más de 30 años"
    },
    
    // Method
    method: {
      label: "El Método",
      title1: "No es fisioterapia clásica.",
      title2: "Traducción del lenguaje del cuerpo.",
      subtitle: "Combino más de 30 años de práctica clínica, enfoque holístico y emoción para ayudarte a entender qué te está tratando de decir tu cuerpo — y qué hacer realmente al respecto.",
      interpretation: "Interpretación",
      interpretationText: "Traduzco dolores, tensiones y bloqueos en mensajes comprensibles. El síntoma finalmente se convierte en una señal con sentido,",
      interpretationHighlight: " no un enemigo a combatir.",
      deep: "Comprensión profunda",
      deepText: "Cada dolor tiene una historia. Juntos la descubrimos y la transformamos.",
      holistic: "Enfoque holístico",
      holisticText: "Cuerpo, mente y espíritu conectados en un recorrido único y personal."
    },
    
    // Ecosystem
    ecosystem: {
      label: "El Método",
      title: "Un ecosistema único",
      subtitle: "Tres niveles progresivos pensados para acompañarte en tu recorrido de bienestar, desde el primer contacto hasta una experiencia completamente personalizada.",
      level1: {
        subtitle: "Entrada Emocional",
        title: "Instagram",
        description: "Sigue @phisioletters para inspiraciones diarias, consejos prácticos y contenidos que nutren cuerpo y mente. El primer paso hacia tu bienestar.",
        cta: "Seguir en Instagram"
      },
      level2: {
        subtitle: "Core Business",
        title: "Comunidad",
        description: "Entra en la comunidad en Skool donde encontrarás videos exclusivos, ejercicios guiados y el apoyo de una comunidad que comparte tu recorrido.",
        cta: "Entrar a la Comunidad"
      },
      level3: {
        subtitle: "Consulta 1:1",
        title: "Premium",
        description: "La experiencia más exclusiva: consultas personalizadas, un plan a tu medida y cartas físicas que te acompañan en tu recorrido.",
        cta: "Descubre Premium"
      },
      popular: "Más popular",
      letterTitle: "Cartas físicas personalizadas",
      letterText: "En el plan Premium recibirás cartas escritas a mano, selladas con cera, que contienen tu plan personalizado, reflexiones y consejos exclusivos. Un toque de autenticidad en un mundo digital.",
      letterCta: "Descubre Premium"
    },
    
    // Pricing
    pricing: {
      label: "Suscripciones",
      title: "Elige tu camino",
      subtitle: "Tres planes pensados para acompañarte en tu viaje de bienestar, desde el primer paso hasta una experiencia completamente personalizada.",
      base: "Básico",
      recommended: "Recomendado",
      exclusive: "Exclusivo",
      popular: "Más popular",
      vip: "VIP",
      month: "/mes",
      subscribe: "Suscríbete",
      becomeVip: "Hazte VIP",
      bookConsultation: "Reservar Consulta 1:1",
      proceed: "Proceder al pago",
      nameLabel: "Tu nombre",
      emailLabel: "Tu email",
      preferredNameLabel: "¿Cómo quieres que te llamemos?",
      preferredNamePlaceholder: "Ej: María, Mari, Marita...",
      note: "Todos los planes incluyen acceso a la comunidad Skool. Cancelación posible en cualquier momento."
    },
    
    // Booking
    booking: {
      label: "Exclusivo Premium Físico",
      title: "Reserva tu consulta 1:1",
      subtitle: "Elige una fecha y hora para tu sesión personalizada con Marlene.",
      premiumOnly: "Disponible exclusivamente para suscriptores Premium Físico (€55/mes).",
      selectDate: "Selecciona una fecha",
      availableSlots: "Horarios disponibles",
      noSlots: "No hay horarios disponibles para esta fecha",
      yourData: "Tus datos",
      fullName: "Nombre completo *",
      email: "Email *",
      notes: "Notas (opcional)",
      notesPlaceholder: "Describe brevemente tus necesidades...",
      summary: "Resumen de la reserva:",
      confirm: "Confirmar Reserva",
      reserved: "Reservado para suscriptores Premium Físico (€55/mes).",
      successTitle: "¡Cita Confirmada!",
      successText: "tu cita ha sido reservada para:",
      emailConfirm: "Recibirás un email de confirmación en"
    },
    
    // Letters
    letters: {
      label: "Área Personal",
      title: "Mis Cartas",
      subtitle: "Ingresa tu email para ver y descargar tus cartas personalizadas.",
      search: "Buscar",
      noLetters: "No se encontraron cartas para este email.",
      checkEmail: "Asegúrate de usar el mismo email con el que te registraste.",
      waiting: "Tus cartas te esperan",
      waitingText: "Como suscriptor Premium, recibes cartas personalizadas cada mes. Ingresa tu email para acceder al archivo completo.",
      notActive: "Suscripción no activa",
      notActiveText: "Puedes ver tus cartas, pero para descargarlas en PDF necesitas una suscripción activa.",
      discoverPlans: "Descubre los Planes",
      backToLetters: "Volver a mis cartas",
      dear: "Querido/a",
      withAffection: "Con cariño,",
      downloadPdf: "Descarga tu carta en PDF",
      pdfNote: "El PDF incluye el encabezado con el logo del estudio",
      downloadReserved: "Descarga reservada para suscriptores",
      downloadReservedText: "Para descargar esta carta en PDF, activa una suscripción."
    },
    
    // Footer
    footer: {
      description: "Un recorrido de bienestar físico y mental guiado por más de 30 años de experiencia. Redescubre tu equilibrio con un enfoque holístico y personalizado.",
      navigate: "Navegar",
      connect: "Conectar",
      communitySkool: "Comunidad Skool",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      rights: "Todos los derechos reservados."
    },
    
    // Success page
    success: {
      verifying: "Verificando pago...",
      wait: "Estamos verificando tu pago, por favor espera.",
      completed: "¡Pago Completado!",
      thanks: "¡Gracias por tu compra! Tu suscripción está activa. Recibirás un email de confirmación con todos los detalles para acceder a la comunidad Skool.",
      summary: "Resumen:",
      amount: "Monto:",
      status: "Estado:",
      paid: "Pagado",
      backHome: "Volver al Inicio",
      expired: "Sesión Expirada",
      expiredText: "La sesión de pago ha expirado. Por favor intenta de nuevo.",
      failed: "Verificación fallida",
      failedText: "No pudimos verificar el pago. Si completaste el pago, contáctanos.",
      backToPlans: "Volver a los Planes",
      patientAreaCta: "Ir al Área Paciente",
      questionnaireHint: "Crea tu cuenta en el Área Paciente y completa el cuestionario inicial para recibir tu programa de ejercicios personalizado."
    },
    
    // Auth
    auth: {
      loginTitle: "Iniciar Sesión",
      registerTitle: "Crea tu cuenta",
      name: "Nombre",
      email: "Email",
      password: "Contraseña",
      loginBtn: "Entrar",
      registerBtn: "Registrarse",
      noAccount: "¿No tienes cuenta? Regístrate",
      haveAccount: "¿Ya tienes cuenta? Inicia sesión",
      welcome: "¡Bienvenido/a!",
      logout: "Salir",
      forgotPassword: "¿Olvidaste tu contraseña?",
      forgotTitle: "Recupera tu contraseña",
      forgotText: "Introduce tu email: te enviaremos un enlace para restablecer tu contraseña.",
      sendLink: "Enviar enlace de recuperación",
      forgotSent: "Si el email existe, recibirás un enlace de recuperación.",
      backToLogin: "Volver al inicio de sesión",
      resetTitle: "Establece una nueva contraseña",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      resetBtn: "Restablecer contraseña",
      resetSuccess: "¡Contraseña actualizada! Ya puedes acceder.",
      passwordMismatch: "Las contraseñas no coinciden"
    },
    
    // Patient Area
    patientArea: {
      label: "Área Privada",
      title: "Mi Programa de Ejercicios",
      welcome: "Hola",
      myLetters: "Mis cartas",
      noAccess: "Programa reservado para suscriptores Premium",
      noAccessText: "El programa de ejercicios personalizado está disponible para suscriptores Premium Digital y Premium Físico. Activa un plan para recibir tu programa.",
      discoverPlans: "Descubre los Planes",
      noProgram: "Tu programa está en preparación",
      noProgramText: "Marlene está preparando tu programa personalizado. Lo encontrarás aquí en cuanto esté listo.",
      questionnaireBanner: "Completa el cuestionario inicial",
      questionnaireBannerText: "Tus respuestas ayudarán a Marlene a preparar tu programa personalizado.",
      fillQuestionnaire: "Completar ahora",
      questionnaireDone: "Cuestionario inicial completado",
      progress: "Progreso del programa",
      sets: "Series",
      reps: "Repeticiones",
      frequency: "Frecuencia",
      rest: "Descanso",
      perWeek: "x/sem.",
      mistakes: "Errores a evitar",
      watchVideo: "Ver el video",
      hideVideo: "Ocultar video",
      completed: "Completado",
      markCompleted: "Marcar como completado",
      today: "Hoy",
      todayTitle: "Para hacer hoy",
      todayNone: "Hoy no hay ejercicios programados: ¡día de recuperación!",
      buy: "Comprar",
      equipmentLabel: "Equipamiento necesario",
      consultTitle: "Tu consulta 1:1 mensual",
      consultText: "Recuerda reservar tu videollamada mensual con Marlene, incluida en tu plan Premium Físico.",
      consultBooked: "Próxima consulta:",
      consultCta: "Reservar ahora",
      streakWeek: "semana seguida — ¡sigue así!",
      streakWeeks: "semanas seguidas — ¡sigue así!",
      difficulty: {
        easy: "Fácil",
        medium: "Medio",
        hard: "Difícil"
      }
    },
    
    // Questionnaire
    questionnaire: {
      title: "Cuestionario Inicial",
      subtitle: "Tus respuestas ayudarán a Marlene a preparar tu programa personalizado.",
      painType: "¿Qué tipo de dolor tienes?",
      painPlaceholder: "Ej: dolor cervical cuando trabajo en la computadora...",
      goal: "¿Cuál es tu objetivo?",
      goalPlaceholder: "Ej: volver a correr sin dolor...",
      equipment: "¿Qué equipamiento tienes en casa?",
      equipmentPlaceholder: "Ej: colchoneta, bandas elásticas, pesas ligeras... (o ninguno)",
      activityLevel: "Nivel de actividad física",
      levels: {
        sedentary: "Sedentario",
        light: "Ligero",
        moderate: "Moderado",
        active: "Activo"
      },
      notes: "Notas adicionales (opcional)",
      submit: "Enviar cuestionario",
      success: "¡Cuestionario enviado! Gracias."
    },
    
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      backHome: "Volver al Inicio",
      notFound: "No encontrado"
    }
  }
};

export default translations;
